import ClearDashboardInfo from './ClearDashboardInfo';

export default ClearDashboardInfo;
